import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Tile } from 'src/app/model/tile.model';

@Injectable()
export class ImageService {
  constructor(private readonly httpClient: HttpClient) {}

  getImage(tile: Tile | string, layer: string = 's'): Observable<Blob | null> {
    if (tile instanceof Tile) {
      const url = `https://mt2.google.com/vt/lyrs=${layer}&x=${tile.x}&y=${tile.y}&z=${tile.z}`;
      return this.httpClient.get(url, { responseType: 'blob' });
    } else if (typeof tile === 'string') {
      return this.httpClient.get(tile, { responseType: 'blob' });
    } else {
      return of(null);
    }
  }
}
